import { authQueryKeys as e } from "../queries/state/useAuthQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { usersApi as r } from "@maat/api-main";
//#region src/phone/useLinkPhoneVerifyMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: r.phoneVerify,
		retry: !1,
		onSuccess: (t) => {
			t.user && i.invalidateQueries({ queryKey: e.me() });
		}
	});
};
//#endregion
export { i as useLinkPhoneVerifyMutation };
